import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import TextCard from "../../TextCard";
import SectionImage, { hasSectionImage } from "../SectionImage";
import { isEnabled } from "utils/booleans";

const RecommendedTo = ({ course }) => {
  const {
    show_section4,
    recommendedTo,
    section4_title,
    section4_bgColor_1,
    section4_bgColor_2,
    section4_use_image,
    section4_image,
    section4_mobile_image,
  } = course;

  if (!isEnabled(show_section4)) return null;
  if (
    section4_use_image &&
    hasSectionImage(section4_image, section4_mobile_image)
  ) {
    return (
      <SectionImage
        image={section4_image}
        mobileImage={section4_mobile_image}
        alt="Curso indicado para"
      />
    );
  }

  return (
    <section
      style={{
        padding: "6rem 0",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        background: `linear-gradient(180deg, ${section4_bgColor_1} 0%, ${section4_bgColor_2} 100%)`,
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "4rem",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: "1rem",
          }}
          dangerouslySetInnerHTML={{ __html: section4_title }}
        />

        <Typography
          variant="h2"
          sx={{
            marginBottom: "1rem",
          }}
          dangerouslySetInnerHTML={{ __html: recommendedTo }}
        />
      </Container>
    </section>
  );
};

export default RecommendedTo;
